<template>
  <v-container>
    <div v-if="alerta">
      <alert-empty></alert-empty>
    </div>
    <v-form>
      <v-container>
        <v-layout>
          <v-flex xs12 md4>
            <v-select
              v-model="nivelValue"
              :items="nivelSelect"
              label="Nivel"
              data-vv-name="listaNiveles"
            ></v-select>
          </v-flex>
          <v-flex xs12 md4>
            <v-select
              v-model="itemsDocumentoValue"
              :items="itemsDocumentosSelect"
              label="Tipo de Documentos"
              data-vv-name="listaTipoDocumento"
            ></v-select>
          </v-flex>
          <v-flex xs12 md4>
            <v-select
              v-model="estadoValue"
              :items="estadoSelect"
              label="Estado"
              data-vv-name="estado"
            ></v-select>
          </v-flex>
          <v-flex xs12 md4>
            <v-menu
              v-model="menu1"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="fechaEvolucion"
                  label="Fecha"
                  prepend-icon="event"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="fechaEvolucion"
                no-title
                @input="menu1 = false"
                locale="es"
                first-day-of-week="1"
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-btn
            fab
            dark
            color="teal"
            title="Filtrar documentos"
            @click="filterDoc()"
          >
            <v-icon dark>filter_list</v-icon>
          </v-btn>
          <v-btn
            fab
            dark
            color="red darken-4"
            title="Limpiar filtros"
            @click="clear()"
          >
            <v-icon dark>clear_all</v-icon>
          </v-btn>
        </v-layout>
        <v-layout>
          <v-toolbar color="white" dark flat dense cad>
            <v-toolbar-title class="indigo--text"
              >Registro de documentos</v-toolbar-title
            >
            <v-spacer></v-spacer>
          </v-toolbar>
        </v-layout>
        <v-layout>
          <v-flex>
            <div v-if="loading">
              <loading></loading>
            </div>
            <grid-documento
              :itemsDocumento="itemsDocumento"
              :rowsTable="rowsTable"
            ></grid-documento>
            <v-spacer></v-spacer>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
import GridDocumento from "./GridDocumento.vue";
import axios from "axios";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";
import Loading from "@/views/ui/Loading.vue";

export default {
  components: {
    GridDocumento,
    AlertEmpty,
    Loading,
  },

  props: {
    proveedor: {},
    show: Boolean,
    tipo: "",
  },
  data() {
    return {
      loading: false,
      rowsTable: [20],
      itemsDocumento: [],
      itemsDocumentosSelect: [],
      nivelSelect: [],
      materialSelect: [],
      estadoSelect: [],
      areaSelect: [],
      nivelValue: null,
      itemsDocumentoValue: null,
      tipomaterialValue: null,
      estadoValue: null,
      areaValue: null,
      filter: false,
      alerta: false,
      fechaEvolucion: "",
      menu1: "",
    };
  },

  computed: {},

  created() {},

  mounted() {
    this.userLogged = this.$store.getters.userLogged.id;
    this.loadData();
    // this.loadNivelSelect()
  },

  methods: {
    async loadDocumentosFilter() {
      this.$store.commit("tab_state", "Validaciones");
      let that = this;
      let subProceso = this.$store.getters.subProTabSelectedStored;
      let idUserLogged = this.$store.getters.userLogged.id;
      let idContrato = this.$store.getters.contratoStored;

      this.body = {
        nivel:
          this.nivelValue && this.nivelValue != null ? this.nivelValue : null,
        tipoDocumento:
          this.itemsDocumentoValue && this.itemsDocumentoValue != null
            ? this.itemsDocumentoValue
            : null,
        tipoMaterial:
          this.tipomaterialValue && this.tipomaterialValue != null
            ? this.tipomaterialValue
            : null,
        estadoValidacion:
          this.estadoValue && this.estadoValue != null
            ? this.estadoValue
            : null,
        area: this.areaValue && this.areaValue != null ? this.areaValue : null,
        // idUserLogged: idUserLogged,
        fecha:
          this.fechaEvolucion != "" && this.fechaEvolucion != null
            ? this.formatoFechaEuropea(this.fechaEvolucion)
            : null,
        subProceso: subProceso,
        idContrato: idContrato,
      };

      return await axios
        .post("/validaciones/filters", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
          return [];
        });
    },
    formatoFechaEuropea(f) {
      // Convierte un texto de la forma europea a la forma americana
      return f.replace(/^(\d{2})-(\d{2})-(\d{4})$/g, "$3-$2-$1");
    },
    async loadData() {
      this.loading = true;
      this.itemsDocumento = await this.loadDocumentosFilter();
      if (this.itemsDocumento.length > 0) {
        this.loadNivelSelect();
        this.loadTipoMaterialSelect();
        this.loadItemsDocumentosSelect();
        this.loadTipoEstadoSelect();
        this.loadAreaSelect();

        this.alerta = false;
      } else {
        this.alerta = true;
      }
      this.loading = false;
    },

    submit() {
      this.$v.$touch();
    },
    clear() {
      this.nivelValue = "";
      this.tipomaterialValue = "";
      this.itemsDocumentoValue = "";
      this.estadoValue = "";
      this.fechaEvolucion = "";
      this.loadData();
    },
    isDisabled() {
      if (this.tipo && this.tipo == "consulta") {
        return true;
      }
    },
    filterDoc() {
      this.filter = true;
      this.loadData();
    },

    loadNivelSelect() {
      let niv = [];
      this.itemsDocumento.forEach(function (d) {
        let index = niv.findIndex((x) => x.tipoDocumento == d.subitem.nivel);
        if (index === -1) {
          if (d.subitem.nivel != null && d.subitem.nivel != "") {
            niv.push(d.subitem.nivel);
          }
        }
      });
      this.nivelSelect = niv;
    },
    loadTipoMaterialSelect() {
      let tipM = [];
      this.itemsDocumento.forEach(function (d) {
        let index = tipM.findIndex(
          (x) => x.tipoMaterial == d.subitem.tipoMaterial
        );
        if (index === -1) {
          if (d.subitem.tipoMaterial != null && d.subitem.tipoMaterial != "") {
            tipM.push(d.subitem.tipoMaterial);
          }
        }
      });
      this.materialSelect = tipM;
    },
    loadItemsDocumentosSelect() {
      let tipP = [];
      this.itemsDocumento.forEach(function (d) {
        let index = tipP.findIndex(
          (x) => x.tipoDocumento == d.subitem.tipoDocumento
        );
        if (index === -1) {
          if (
            d.subitem.tipoDocumento != null &&
            d.subitem.tipoDocumento != ""
          ) {
            tipP.push(d.subitem.tipoDocumento);
          }
        }
      });
      this.itemsDocumentosSelect = tipP;
    },
    loadTipoEstadoSelect() {
      let tipE = [];
      this.itemsDocumento.forEach(function (d) {
        let index = tipE.findIndex(
          (x) => x.estadoValidacion == d.estadoValidacion
        );
        if (index === -1) {
          if (d.estadoValidacion != null && d.estadoValidacion != "") {
            tipE.push(d.estadoValidacion);
          }
        }
      });
      this.estadoSelect = tipE;
    },
    loadAreaSelect() {
      let are = [];
      this.itemsDocumento.forEach(function (d) {
        let index = are.findIndex((x) => x.area == d.subitem.area);
        if (index === -1) {
          if (d.subitem.area != null && d.subitem.area != "") {
            are.push(d.subitem.area);
          }
        }
      });
      this.areaSelect = are;
    },
    alert() {},
  },
};
</script>
